import { GOLD_HOME_TAB } from 'Containers/LikesYou/constants';

import type { LikesYouState } from './types';

const initialState: LikesYouState = {
  count: 0,
  countLoading: false,
  fastMatches: [],
  fastMatchesLoaded: false,
  fastMatchesLoading: false,
  fastMatchesSwiped: [],
  fastMatchTeasers: [],
  fastMatchTeasersLoaded: false,
  fastMatchTeasersLoading: false,
  goldHomeSeen: false,
  isRange: true,
  lastFastMatch: null,
  lastTab: GOLD_HOME_TAB,
  newLikesCount: 0,
  nextPageToken: null,
  prevSessionLikeCount: 0,
  recentlyActiveGoldTeaser: {
    url: '',
    name: '',
  },
  teaserUrl: '',
};

export default initialState;
